/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { Card, Form, Input, Typography } from 'antd';

import { useMimicTranslation } from '@/hooks/useMimicTranslation';
import { Container } from '@/primitives/Container';
import { Text } from '@/primitives/Text';

const { Title } = Typography;

interface SignatureAlgSectionProps {
  readOnly?: boolean;
}

export function SignatureAlgSection({ readOnly = false }: SignatureAlgSectionProps) {
  const { t } = useMimicTranslation('oauthClients');

  return (
    <Card>
      <Container gap="md">
        <Title level={4} style={{ margin: 0 }}>
          {t('clientForm.advancedSettings')}
        </Title>

        <div style={{ width: '100%' }}>
          <Form.Item
            label={<Text style={{ fontWeight: '600' }}>{t('clientForm.signatureAlgLabel')}</Text>}
            name="idTokenSignatureAlg"
            initialValue="RS256"
            extra={<span style={{ color: '#8c8c8c', fontSize: '13px' }}>{t('clientForm.signatureAlgOnlyRS256')}</span>}
            style={{ marginBottom: 0 }}
          >
            <Input
              value="RS256"
              disabled
              readOnly={readOnly}
              style={{
                borderRadius: '4px',
                fontSize: '14px',
                width: '100%',
              }}
            />
          </Form.Item>
        </div>
      </Container>
    </Card>
  );
}
